import { useAppSelector } from "../../../../stateManagement/hooks/redux"
import { setDownloadSelectedDocumentsButtonIsClicked } from "../../../../stateManagement/reducers/TableButtonsRowSlice"
import { store } from "../../../../stateManagement/store"
import { TableButton } from "./TableButton"

export default function TableButtonsRow({ type }: any) {

    const selectedDocumentsAreLoading = useAppSelector(state => state.documents.selectedDocumentsAreLoading)

    const downloadSelectedDocumentsButtonIsVisible = type === "documents"

    function controlDownloadSelectedDocumentsButton() {
        store.dispatch(setDownloadSelectedDocumentsButtonIsClicked(true))
    }

    const widgetsConfigArray = [
        {
            visible: downloadSelectedDocumentsButtonIsVisible,
            name: "Скачать выбранные документы",
            loading: selectedDocumentsAreLoading,
            onClick: controlDownloadSelectedDocumentsButton,
            className: "download-multiple-documents-button"
        }
    ]

    return (
        <div className="table-buttons-row-div">
            {widgetsConfigArray.map((tableButtonsRowWidget: any, index) => {
                const { visible, name, onClick, loading, className } = tableButtonsRowWidget ?? {}
                const buttonIsVisible = ('visible' in tableButtonsRowWidget && visible) || !('visible' in tableButtonsRowWidget)
                if (buttonIsVisible) {
                    return (
                        <TableButton
                            key={`${name}-${index}`}
                            isLoading={loading}
                            name={name}
                            onClick={onClick}
                            addClassName={className}
                        />
                    )
                }
            })}
        </div>
    )
}
